<template>
    <div class="coupon-code">
        <span
            v-if="!show"
            class="coupon-btn"
            @click="show = true"
        >
            Have a code?
        </span>

        <fieldset
            class="coupon-field"
            :class="{ error: false === isValid, hidden: !show, success: true === isValid }"
        >
            <input
                v-model="code"
                v-debounce:500="() => validateCoupon(code)"
                placeholder="Coupon"
                type="text"
                required
                autocomplete="off"
                :disabled="disabled"
                :class="['coupon-input', { error: false === isValid, success: true === isValid }]"
            >
            <label class="coupon-label">
                Enter your promo code
            </label>
        </fieldset>

        <span
            v-if="error"
            class="form-error coupon-error"
        >
            {{ error }}
        </span>

        <span
            v-if="isValid && promo.id"
            class="promo-info"
        >
            <span v-if="promo.type == 'trial'">Promo {{ promo.name }} applied. You get {{ promo.data.days }} days free.</span>
            <span v-if="promo.type == 'coupon'">The coupon has been successfully applied.</span>
        </span>
    </div>
</template>
<script>
import apiCall from '@/utils/apiCall';

export default {
    props: {
        initialCode: {
            type: String,
            default: null,
        },
        billingPlan: {
            required: true,
            type: [Object, Boolean],
        },
        validateImmediatelly: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        show: false,
        isValid: null,
        code: null,
        error: '',
        promo: {},
    }),

    /**
     * Sets coupon code from cookie.
     */
    async mounted() {
        const couponCode = this.$cookies.get('fusebox_promo') || this.initialCode;

        if (! this.validateImmediatelly) {
            this.code = couponCode;
        } else if (couponCode) {
            await this.validateCoupon(couponCode);

            if (this.isValid) {
                this.code = couponCode;
                this.show = true;

                this.$emit('change', this.code);
            } else {
                // Do not render error on component mount.
                this.error = null;
            }
        }
    },

    methods: {
        /**
         * Validates coupon code
         *
         * @param {string} code Coupon code to validate.
         */
        async validateCoupon(code) {
            if (! code) {
                this.error = null;
                this.isValid = null;
            } else {
                const { status, data } = await apiCall(
                    this,
                    'post',
                    `${this.$appUrl}/api/billing/promo/${code}`,
                    { plan: this.billingPlan.slug }
                );

                if (! [200, 201].includes(status)) {
                    this.error = 'Invalid promo code';
                    this.isValid = false;
                    this.promo = {};
                } else {
                    this.error = null;
                    this.isValid = true;
                    this.promo = { ...data };
                }
            }

            this.$emit('change', this.isValid ? this.code : null);
        },
    },
};
</script>
